import { render, staticRenderFns } from "./DonutChart26.vue?vue&type=template&id=c08e00fa&scoped=true&"
import script from "./DonutChart26.vue?vue&type=script&lang=js&"
export * from "./DonutChart26.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08e00fa",
  null
  
)

export default component.exports